<template>
  <div id="pdf-template-input">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">{{$t('pdf_template_input.name')}}</span>
      </div>
      <input
        v-model="template.name"
        type="text"
        class="form-control"
        aria-describedby="basic-addon1"
      />
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">{{$t('pdf_template_input.width')}}</span>
      </div>
      <input
        v-model="template.width"
        type="number"
        min="0"
        max="210"
        class="form-control"
        aria-describedby="basic-addon1"
      />
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">{{$t('pdf_template_input.height')}}</span>
      </div>
      <input
        v-model="template.height"
        type="number"
        class="form-control"
        min="0"
        max="297"
        aria-describedby="basic-addon1"
      />
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">{{$t('pdf_template_input.margin_left')}}</span>
      </div>
      <input
        v-model="template.margin_left"
        type="number"
        min="0"
        class="form-control"
        aria-describedby="basic-addon1"
      />
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">{{$t('pdf_template_input.margin_top')}}</span>
      </div>
      <input
        v-model="template.margin_top"
        type="number"
        min="0"
        class="form-control"
        aria-describedby="basic-addon1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "pdf-template-input",
  props: {
    template: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style>
</style>